import React from "react";

const SvgSurveyDark = props => (
  <svg width={24} height={24} {...props}>
    <defs>
      <path
        id="survey-dark_svg__a"
        d="M11.041 22.764V12.406a1.678 1.678 0 0 1 .932-3.076c.931 0 1.685.749 1.685 1.674 0 .68-.411 1.266-.987 1.525v10.235c0 .45-.37.817-.822.817a.81.81 0 0 1-.808-.817zm5.027-8.452a.804.804 0 0 0 1.123-.272 5.871 5.871 0 0 0 .864-3.349c-.137-3.294-2.945-5.866-6.274-5.744A5.988 5.9880 0 0 7.616 6.88a5.89 5.89 0 0 0-1.589 4.301 5.98 5.98 0 0 0 .74 2.654.818.818 0 0 0 1.123.313.82.82 0 0 0 .315-1.116 4.5 4.5 0 0 1-.548-1.933 4.403 4.403 0 0 1 1.151-3.13c.781-.858 1.89-1.334 3.055-1.388 2.41-.096 4.466 1.769 4.562 4.178a4.25 4.25 0 0 1-.63 2.436.813.813 0 0 0 .273 1.117zm2.411 3.144a.843.843 0 0 0 1.165-.096A9.94 9.94 0 0 0 22 10.936C22 5.451 17.52 1 12 1S2 5.452 10.936c0 2.49.931 4.86 2.616 6.697a.827.827 0 0 0 .603.272.78.78 0 0 0 .548-.218.827.827 0 0 0 .055-1.157 8.266 8.266 0 0 1-2.178-5.594c0-4.573 3.753-8.303 8.356-8.303s8.356 3.73 8.356 8.303c0 1.96-.698 3.866-1.972 5.363a.805.805 0 0 0 .095 1.157z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="survey-dark_svg__b" fill="#fff">
        <use xlinkHref="#survey-dark_svg__a" />
      </mask>
      <use fill="#000" fillRule="nonzero" xlinkHref="#survey-dark_svg__a" />
      <g fill="#091E42" mask="url(#survey-dark_svg__b)">
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
);

export default SvgSurveyDark;